import React, { useState, useEffect } from "react";
import {
  Dialog,
  Select,
  Grid,
  InputLabel,
  MenuItem,
  Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { languages } from "../globals/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#000 !important",
    borderRadius: "5px",
    width: "600px !important",
    padding: "10px",
    margin: "8px 0px 20px 0px",
  },
  popup: {
    position: "relative",
    height: "700px !important",
    width: "500px",
    borderRadius: "10px",
    padding: "0px !important",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  popupContent: {
    backgroundColor: "black",
    color: "white",
    padding: theme.spacing(2),
    maxWidth: "80%",
    zIndex: 10000,
  },
  closeIcon: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  title: {
    fontSize: "20px !important",
    textAlign: "center !important",
    color: "#FFF !important",
    padding: "30px !important",
  },
  selectedItem: {
    backgroundColor: "#f0f8ff !important",
    fontWeight: "bold !important",
  },
}));

const LanguageChange = ({ open, onClose }) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || "en");

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  const handleLanguageChange = (event) => {
    const value = event.target.value;
    setLanguage(value);
    i18n.changeLanguage(value);
    // Store user's explicit language choice and set the boolean flag
    localStorage.setItem("i18nextLng", value);
    localStorage.setItem("userSelectedLanguage", "true");
  };

  const handleSubmit = () => {
    onClose();
  };

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div style={{ background: "#FFF", width: "300px", height: "250px" }}>
        <InputLabel
          style={{ textAlign: "center", marginTop: "20px", fontWeight: 700 }}
        >
          {t("Select Language")}
        </InputLabel>

        <Grid item xs={12} sm={12} sx={{ padding: "20px" }}>
          <Select
            value={language}
            onChange={handleLanguageChange}
            fullWidth
            variant="outlined"
            MenuProps={MenuProps}
            sx={{
              borderRadius: 3,
              background: "#FFFFFF",
              marginTop: "0.4rem",
            }}
          >
            {languages.map((lang) => (
              <MenuItem
                key={lang.value}
                value={lang.value}
                className={language === lang.value ? classes.selectedItem : ""}
              >
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <div
          style={{
            width: "120px",
            margin: "auto",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Button onClick={handleSubmit}>{t("Submit")}</Button>
        </div>
      </div>
    </Dialog>
  );
};

export default LanguageChange;
